<template>
  <ul class="nav nav-pills flex-column list-unstyled mb-0 flex-shrink-0">
    <SidenavElement
      itemClass="nav-item mb-2"
      :to="{ name: 'Ecolabels' }"
      :isActive="isEcolabelsActive"
      icon="fa-solid fa-leaf"
      :text="$t('ecolabels.title')"
    />
  </ul>

  <CompanySidenavList
    :accountData
    :showConsolidatedEntry="false"
    :showFollowups="false"
  />

  <PoweredBySolderaBadge />

  <div
    v-if="accountData.admin_account_id"
    class="d-flex align-items-center justify-content-end flex-shrink-0"
  >
    <AdminCompanyAccessButton :accountData />
  </div>
</template>

<script setup lang="ts">
import AdminCompanyAccessButton from "@/components/layout/AdminCompanyAccessButton.vue";
import CompanySidenavList from "@/components/layout/CompanySidenavList.vue";
import SidenavElement from "@/components/layout/SidenavElement.vue";
import type { Account } from "@/types";
import { computed } from "vue";
import { useRoute } from "vue-router";
import PoweredBySolderaBadge from "./PoweredBySolderaBadge.vue";

// The restricted ecolabel-provider sidenav: Ecolabels, the company list
// (no consolidated view, no producer follow-ups), and Soldera attribution.
defineProps<{
  accountData: Account;
}>();

const route = useRoute();

const isEcolabelsActive = computed(() => {
  return route.name === "Ecolabels";
});
</script>
